import React, { useState, useContext, useEffect } from 'react';
import { faEdit, faTrash, faEye, faCartPlus } from '@fortawesome/pro-regular-svg-icons'

import APICtx from '#api'
import CartCtx from './cart'
import { TplWSidebar as Tpl } from '#Template'
import Table from '#Table'
import Search, { SearchText } from '#Search'
import CreateDial from './CreateDial'
import EditBar from './EditBar'
import Dialog from '#Dialog'

const ACCESSORIES_SHORTMODE_LIMIT = 4

function Accessory({ _id }) {
	const api = useContext(APICtx)
	const [ data, setData ] = useState({})
	
	const handleRefresh = () => {  api.call('accessory/get/'+_id).then(setData) }
	useEffect(handleRefresh, [ _id ])

	return data?.name ? (data.name + (data.active ? '' : ' [NON ATTIVO]')) : ''
}

function Accessories({ accessories }) {
	const [ showAccessoryDiag, setShowAccessoryDiag ] = useState(false)
	const ids = accessories || []

	const hiddenAccessories = ids.length > ACCESSORIES_SHORTMODE_LIMIT ? ids.length-ACCESSORIES_SHORTMODE_LIMIT : 0
	return (
		<ul>
			{ ids.slice(0, ACCESSORIES_SHORTMODE_LIMIT).map(accessoryId => (
				<li>
					<Accessory key={accessoryId} _id={accessoryId} />
				</li>
			))}
			{ Boolean(hiddenAccessories) && (
				<li>
					<a href="#" onClick={() => setShowAccessoryDiag(true)}>(Altri {hiddenAccessories})</a>
					<Dialog handleClose={() => setShowAccessoryDiag(false)} title="Elenco accessori" open={showAccessoryDiag} width="md">
						<ul>
							{ ids.map(accessoryId => (
								<li>
									<Accessory key={accessoryId} _id={accessoryId} />
								</li>
							))}
						</ul>
					</Dialog>
				</li>
			)}
		</ul>
	)
}

const tabDef = [
	{ label:"Nome", content:({ name, active }) => name + (active ? '' : ' [NON ATTIVO]') },
	{ label:"Prezzo", type:'money', content:({ price }) => price },
	{ label:"Accessori collegati", content:row => <Accessories {...row} /> },
]

export default function QuoteProductList() {
	const api = useContext(APICtx)
	const cart = useContext(CartCtx)
	const [ srcString, setSrcString ] = useState('')
	const [ ids, setIds ] = useState([])

	const handleRefresh = () => api.call('product/list', { fullTree:true, srcString }).then(setIds)
	const handleAddToCart = ({ _id }) => cart.chQuantity({ product:_id, delta:1 })
	const handleDelete = ({ _id, name }) => {
		api.dialogConfirm({
			text: 'Sei sicuro di voler cancellare il prodotto "'+name+'"?',
			onConfirm: () => api.call('product/del/'+_id).then(handleRefresh),
		})
	}
	useEffect(() => { handleRefresh() }, [ api, srcString ])

	const getRow = _id => api.call('product/get/'+_id)
	const defBtns = [
		{ icon:faEye, label:"Visualizza", linkTo:({ _id }) => "/quote/product/view/"+_id },
	]
	if(api.chkAuth('quote-trader'))
		defBtns.push({ icon:faCartPlus, label:"Aggiungi al carrello", onClick:handleAddToCart })
	if(api.chkAuth('quote-editor'))
		defBtns.push(
			{ icon:faEdit, label:"Modifica", linkTo:({ _id }) => "/quote/product/edit/"+_id },
			{ icon:faTrash, label:"Elimina", onClick:handleDelete },
		)

	return (
		<Tpl title='Elenco prodotti'>
			<EditBar />
			<Search>
				<SearchText label="Cerca" name="src-text" onChange={setSrcString} />
			</Search>
			<Table def={tabDef} defBtns={defBtns} ids={ids} getRow={getRow} pageSize={30} pageSizeOpts={[ 30, 50 ]} />
			<CreateDial />
		</Tpl>
	)
}